const Project = (props) => {
	const id = props.id
	const name = props.name
	const askFortasks = props.askFortasks
	return (
		<div id={id} className="btn-projects all-btns" onClick={askFortasks}>
			<span id={id} className="material-symbols-outlined">
				quick_reference
			</span>
			<span id={id} className="projectTitle">
				{name}
			</span>
		</div>
	)
}

export default Project
